import React, {useState} from 'react';
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import GoogleDisc from "../../../components/svg/GoogleDisc";
import {Link} from "react-router-dom";

const StatusPlate = () => {
  const [loading, setLoading] = useState(false)
  const statusToGoogle = () =>{
    setLoading(true)
    axios.post('/api/fromOneC/createStatus')
      .then(()=>{
        window.alert('Статус создан')
      }).finally(()=>setLoading(false))
  }
  return (
    <Portlet>
      <PortletHeader title={'Создание статуса'} toolbar={<PortletHeaderToolbar className={'gap-3'}>
        <LoadingButton loading={loading}
                       onClick={statusToGoogle}
                       size={'sm'}
                       title={loading ? 'Выгружаю...' : 'Выгрузить'}/>
        <Link to={'https://docs.google.com/spreadsheets/d/'+process.env.REACT_APP_GOOGLE_STATUS_SHEET_ID} target={'_blank'}>
            <GoogleDisc/>
        </Link>
      </PortletHeaderToolbar>}/>
    </Portlet>
  );
};

export default StatusPlate;
